import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EnergyService } from '../../../../operational-data-common/services/energy.service';

import { FeaturePropertyKey } from '../../../../../projects/client';
import { SeriesSummary } from '../../models/chart.model';

@Component({
  selector: 'app-period-summary',
  templateUrl: './period-summary.component.html',
  styleUrls: ['./period-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeriodSummaryComponent {
  readonly featurePropertyKey = FeaturePropertyKey;

  @Input() periodName: string;
  @Input() periodSingularName: string;
  @Input() seriesSummary: SeriesSummary[];
  @Input() amountOfTheValuesWithinThePeriod: number;

  constructor(public energyService: EnergyService) {}
}
